import _ from "underscore";
import Tether from 'tether'
import { parseZone } from '../helpers/parseZone.js';
import {
  check_auth_token_path,
  login_path,
  configure
} from '~/routes';

window.pdfDebug = function(message){
  //NOP, defined in pdf.js
 }

//Turbo.enableProgressBar();

// TODO: Clean up. Bunch of different actions randomly initialized. :(

// Prevent the browser from following the href # links
$(document).on('turbo:click', function (event) {
  if (event.target.getAttribute('href') && event.target.getAttribute('href').charAt(0) === '#') {
    return event.preventDefault();
  }
})

window.trimBlankInputField = function() {
  jQuery('.trim-blank').off('blur').on('blur', function(e){
    jQuery(this).val(jQuery(this).val().trim());
  });
}

// Plugin defaults
window.initPluginDefaults = function() {
  if (document.querySelector('body').getAttribute('data-programme-identifier') != '') {
    configure({
      default_url_options: {programme_identifier: document.querySelector('body').getAttribute('data-programme-identifier')}
    });
  }
  
  // Localize datatables
  if(typeof jQuery.fn.dataTable !== 'undefined' && typeof I18n.t('dt') !== 'undefined') {
    $.fn.dataTable.ext.errMode = 'throw';   // Use throw instead fo alert for datatable errors

    jQuery.extend( true, jQuery.fn.dataTable.defaults, {
      "language": {
        "lengthMenu": I18n.t('dt')['length_menu'].replace('%{param}', '_MENU_'),
        "zeroRecords": I18n.t('dt')['zero_records'],
        "info": I18n.t('dt')['info'].replace('%{start}', '_START_').replace('%{end}', '_END_').replace('%{total}', '_TOTAL_'),
        "infoEmpty": I18n.t('dt')['info_empty'],
        "emptyTable": I18n.t('dt')['empty_table'],
        "infoFiltered": I18n.t('dt')['info_filtered'].replace('%{max}', '_MAX_'),
        "paginate": {
          "first": I18n.t('dt')['first'],
          "last": I18n.t('dt')['last'],
          "next": I18n.t('dt')['next'],
          "previous": I18n.t('dt')['previous']
        },
        "loadingRecords": I18n.t('dt')['loading_records'],
        "processing": I18n.t('dt')['processing'],
        "search": I18n.t('dt')['search']
      }
    });
  }


  // TinyMCE fix for bootstrap dialogs: https://stackoverflow.com/questions/18111582/tinymce-4-links-plugin-modal-in-not-editable
  $(document).on('focusin', function(e) {
    if ($(e.target).closest(".mce-window").length) {
        e.stopImmediatePropagation();
    }
    // Fix for flatpickr calendars disappearing on bootstrap dialog
    if ($(e.target).closest('.flatpickr-calendar').length) {
      e.stopImmediatePropagation();
    }
  });
}

var SmartME = {};
SmartME.loadingIndicator = function(height, wrapperStyle = {} ) {
	if (typeof height == 'undefined') {height = 150};
	var indicator = jQuery('<div>').addClass('loading-indicator').css({'height': height+'px','width': (height/2)+'px', ...wrapperStyle});
	indicator.append('&nbsp;');
	indicator.append(jQuery('<div>').addClass('loading-box1 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box2 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box3 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box4 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box5 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box6 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box7 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box8 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box9 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box10 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box11 loading-box'));
	indicator.append(jQuery('<div>').addClass('loading-box12 loading-box'));
	return indicator;
};

SmartME.setLoadingIndicator = function(container, options) {
  options = options || {};
  var indicator = SmartME.loadingIndicator(options.height);

  if (options.overlay) {
    var c = jQuery(container);
    c.addClass('loading-indicator-container');
    c.append(jQuery('<div class="loading-indicator-overlay"></div>').append(indicator));
  } else {
    jQuery(container).html(indicator);
  }
}

SmartME.removeLoadingIndicator = function (container) {
  var c = jQuery(container);

  if (c.find('.loading-indicator-overlay').length > 0) {
    c.removeClass('.loading-indicator-container').find('.loading-indicator-overlay').remove();
  } else {
    c.find('.loading-indicator').remove();
  }
}

SmartME.generateUniqueId = function(length) {
  length = (typeof length != 'undefined' ? length : 6)
  var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var randomString = 'id'; // To have it begin with letter
  for (var i = 0; i < length; i++) {
      var randomPos = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPos, randomPos + 1);
  }
  return randomString;
};


SmartME.linkToModal = function(label, href, options) {
	options = options || {};
  
  $link = $('<a>').attr('href', href).html(label);
  $link.addClass((options.class || '') + ' modal-dialog-link');
	if (options.buttons == false) {
  	$link.attr('data-hide-buttons', 'true');
  }
  $link.attr('data-save-label', options.save_label || 'Save');
  $link.attr('data-title', options.title || '&nbsp;');
  $link.attr('data-modal-class', (options.size ? 'modal-'+ options.size : ''));

  return $link;
};



SmartME.formatNumber = function(value, format) {
  var s = format.split(/[\-\d]+/).slice(1,3);
  function addSeparators(n, sep){
    var r = /(\d+)(\d{3})/;
    return String(n).replace(/^\d+/, function(w){
      while(r.test(w)){
        w = w.replace(r, '$1' + s[0] + '$2');
      }
      return w;
    });
  }

  function meaningfulDecimals(decimalPart, decimalSeparator) {
    // Remove trailing zeros
    var dp = (decimalPart || '').replace(/0+$/, "");
    // Not meaningfull
    if ( dp.length == 0) {
      return '';
    } else {
      return decimalSeparator + dp;
    }
  }

  var val = parseFloat(value).toString().split('\.');
  return addSeparators(val[0], format) + meaningfulDecimals(val[1], s[1]);
};



SmartME.formatCurrency = function(value, format) {
  var s = format.split(/[\-\d]+/).slice(1,3);
  function addSeparators(n, sep){
    var r = /(\d+)(\d{3})/;
    return String(n).replace(/^\d+/, function(w){
      while(r.test(w)){
        w = w.replace(r, '$1' + s[0] + '$2');
      }
      return w;
    });
  }

  var val = String(value).split('\.');
  return addSeparators(val[0], format) + s[1] + (parseInt(val[1]) > 0 ? val[1] : '00').substring(0,2);
};


SmartME.zeroPad = function (num, len) {
  len = len || 2;
  return (num.toString().length < (len) ? (Math.pow(10, (len)).toString().slice(1) + num).slice(-(len)) : num.toString());
};


  SmartME.renderLoginDialog = function(callback) {
    if (typeof callback === 'undefined') {
      callback = function() {};
    }
    var dialog = jQuery('#modal-dialog');
    dialog.find('.modal-footer').hide();
    dialog.find('.modal-header').hide();
    dialog.find('.modal-body').html('');
    
    dialog.modal();
    dialog.find('.modal-body').css('display', 'flex')
    dialog.find('.modal-body').append('<div class="col-xs-8 col-xs-offset-2 login-form"></div>')
    dialog.find('.col-xs-8').html(SmartME.loadingIndicator());
    dialog.find('.col-xs-8').load(login_path({format: null, session_expired: 't'}), function() {
      AdaliaForm.init('#modal-dialog');
      dialog.trigger('modal:loaded');

      dialog.find('.login-status-row:not(.previous,.logout)').off('click');
      dialog.find('.login-status-row:not(.previous,.logout)').on('click', function() {
        var authenticityToken = jQuery('form.login').find('input[name="authenticity_token"]').val();
        SmartME.updateAuthToken(authenticityToken);
        dialog.modal('hide');
        callback();
      });
    });

    dialog.find('.modal-body').off('submit').on('submit', 'form', function(){
      jQuery.post(jQuery(this).attr('action'), jQuery(this).serialize() + '&login_programme_id=' + jQuery('body').data('programme-id'), function(data){
        /// TODO: AUTHENCITY TOKEN UPDATE
        if(data.status){
          SmartME.updateAuthToken(data.token);
          dialog.modal('hide');
          callback();
        } else {
          dialog.find('.col-xs-8').html(data);
        }
      });
      return false;
    })

  };


  SmartME.updateAuthToken = function(token) {
    // Update csrf tokens
    jQuery('meta[name="csrf-token"]').attr('content', token);
    jQuery('input[name="authenticity_token"]').attr('value', token);
  };

  SmartME.checkLoginTimeout = setTimeout(function() {
    SmartME.checkLoginTimeout = null;
  }, 60 * 1000);

  SmartME.checkLogin = function() {
    if (jQuery('#modal-dialog').find('.login-status-row:visible,form.login:visible').length > 0) {
      return false;
    }
    
    if (typeof Routes !== 'undefined' && SmartME.checkLoginTimeout === null) {
      $.post(check_auth_token_path({format: null, current_url: window.location.href})).error(function(data) {
        if (data.status == 422 && data.responseText.match("NoActiveSession")) {
          SmartME.renderLoginDialog();
        } else if (data.status == 422 && data.responseText.match("InvalidAuthenticityToken")) {
          SmartME.updateAuthToken(JSON.parse(data.responseText).token);
        } else if (data.status == 307) {
          window.location.href = data.responseText;
        }
      });
      SmartME.checkLoginTimeout = setTimeout(function() {
        SmartME.checkLoginTimeout = null;
      }, 60 * 1000);
    }
  };

SmartME.resizeNavTabs = function(ulSelector) {
  var ul = jQuery(ulSelector);

  ul.find('li').each(function() {
    var li = jQuery(this);
    li.css('flex', li.text().length + ' 1 0%');
  });
};

SmartME.formatResultSelect2 = function(result) {
  var content = jQuery.parseJSON(result.text);
  var retval = jQuery('<div>').css({
    'border-top': '1px dotted #7FAEF9',
    'padding-left': 5*content.number.split('.').length + 'px'});
  retval.append(jQuery('<div>').html(SmartME.formatTitleSelect2(result)));
  var css = {'white-space':'nowrap', 'text-overflow':'ellipsis', 'overflow':'hidden'};
  retval.append(jQuery('<div>').css(css).html(content.description));
  return jQuery('<div>').append(retval).html();
}

SmartME.formatTitleSelect2 = function(result) {
  var content = jQuery.parseJSON(result.text);
  return content.type + ' ' + content.number;
}


SmartME.animateDecimal = function(fromValue, toValue, duration, callback) {
  var interval = 25;

  if (isNaN(fromValue)) {
    var fromValue = 0
  }

  var val = fromValue;
  var steps = duration/interval;
  var stepSize = (toValue-fromValue)/steps;
  var t = setInterval(function() {
    val = val + stepSize;
    if ((fromValue <= toValue && val >= toValue) || (fromValue >= toValue && val <= toValue)) {
      clearInterval(t);
      callback(toValue);
    }
    else {
      callback(val);
    }
  }, interval);
}


// SmartME.sortableResultNumber = function(version) {
//   version = String(version).split('.');
//   var returnVersion = ['','','','','','',''];
//   $.each(version, function(i,e) {returnVersion[i] = ('000'+e).slice(-3)});
//   return returnVersion.join('');
// }



var tokenRefreshInit = function() {
  // Abort xhr get requests when navigating from the page
  $.xhrPool = [];
  $.xhrPool.abortAll = function () {
    $($.xhrPool).each(function (i, jqXHR) {
      jqXHR.abort();
    });
    $.xhrPool.length = 0;
  }
  
  // These are default values for $.ajax requests and overridden if defined in the request
  $.ajaxSetup({
    beforeSend: function (jqXHR, settings) {
      if (settings.type.toUpperCase() == 'GET') {
        $.xhrPool.push(jqXHR);
      }
    },
    complete: function (jqXHR) {
      var i = $.xhrPool.indexOf(jqXHR);
      if (i > -1) $.xhrPool.splice(i, 1);
    }
  });

  // Unload event
  $(window).off("beforeunload", $.xhrPool.abortAll).on("beforeunload", $.xhrPool.abortAll);
  // Backbutton
  $(window).off("popstate", $.xhrPool.abortAll).on("popstate", $.xhrPool.abortAll);
  // Turbo
  $(document).off("page:before-change turbo:before-visit", $.xhrPool.abortAll).on("page:before-change turbo:before-visit", $.xhrPool.abortAll);


    // Adjust content to system message
    if (jQuery('.system-message').length > 0) {
      if (jQuery('.navbar').length > 0) {
        jQuery('.system-message').css({ top: jQuery('.navbar').outerHeight() });
      } else {
        jQuery('.system-message').css({ top: 0 });
      }
      SystemMessageHelper.adjustContent(1);
      SystemMessageHelper.addClosingListener();
    }

  	$(window).on('click', function(e){
      const $popovers = $('.popover');
      if ($popovers.length){
        $popovers.popover('hide');
      }
  	});

    jQuery('.set-locale').off('click').on('click', function(e){
      e.preventDefault();

      var $link = jQuery(this);
      $link.css('opacity', 0.7).text(I18n.t('loading'));

      jQuery.post($link.data('url')).done(function(){
        window.location.href = $link.data('redirect-url');
      });

      return false;
    });

  	$('div.read-more-toggle').each(function(){
  		if ($(this).height() < $(this).find('div.read-more-content').height()) {
	  		if ($(this).find('.read-more-toggle-button').length == 0) {
			  	var showLink = $('<a>').attr('href', '#').addClass('read-more-toggle-button').html($('<span>').addClass('glyphicon glyphicon-option-horizontal').text($(this).data('expand-text')));
			  	var hideLink = $('<a>').attr('href', '#').addClass('read-more-toggle-button hidden').html($('<span>').addClass('glyphicon glyphicon-option-horizontal').text($(this).data('hide-text')));

			  	if ($(this).data('open-text')) {
			  		showLink.html($(this).data('open-text'));
			  	}

			  	if ($(this).data('close-text')) {
			  		hideLink.html($(this).data('close-text'));
			  	}

			  	showLink.on('click', function() {
			  		$(this).closest('div.read-more-toggle').addClass('expanded');
			  		$(this).addClass('hidden');
			  		hideLink.removeClass('hidden');
			  		return false;
			  	});
			  	hideLink.on('click', function() {
			  		$(this).closest('div.read-more-toggle').removeClass('expanded');
			  		$(this).addClass('hidden');
			  		showLink.removeClass('hidden');
			  		return false;
			  	});

			  	$(this).append(hideLink);
			  	$(this).append(showLink);
			  }
			}
		});

		$('.edit-inplace:not(.initialized)').each(function(i,e) {
			$(this).addClass('initialized');
			var $container = $('<div>').addClass('inplace-edit-container');
			var $field = $(this);
			$field.after($container);
			$field.appendTo($container);
			$field.attr('contenteditable', true);
			$field.on('focus', function() {
				$container.addClass('editing');
				if ($container.find('.inplace-button').length == 0) {
					$container.data('old-value', $field.text());
					var $save = $('<span>').addClass('inplace-button save fa fa-check');
					$save.on('click', function() {
						$field.trigger('change');
						$container.removeClass('editing');
					});
					var $cancel = $('<span>').addClass('inplace-button cancel fa fa-remove');
					$cancel.on('click', function() {
						$field.text($container.data('old-value'));
						$(this).closest('.inplace-edit-container').find('.inplace-button').remove();
						$container.removeClass('editing');
					});
					$field.after($save);
					$field.after($cancel);
				}
			});
			$field.on('blur', function() {
				if ($container.data('old-value') == $field.text()) {
					$container.find('.inplace-button.cancel').trigger('click');
				}
			});
		});
    const $popovers = $('[data-toggle="popover"]');
    if ($popovers.length){
      $popovers.popover();
    }
    var checkLoginThrottled = _.throttle(SmartME.checkLogin, 1000);

    $(window).off('mousemove', checkLoginThrottled);
    $(window).on('mousemove', checkLoginThrottled);

    // Resize navigation tabs to fit better in width
    SmartME.resizeNavTabs('ul[data-resize-nav-tabs="true"]');

}

window.tokenRefreshInit = tokenRefreshInit;

// smartme-toggle
(function($) {
  $.fn.smartmeToggle = function() {
    this.addClass("smartme-toggle");
    this.each(function() {
    	var $toggle = $(this);
    	var $container = $('<span>').addClass('smartme-toggle-content')
    	var $yes = $('<span>').addClass('option option-yes');
    	var $no = $('<span>').addClass('option option-no');
      var $input = $('<input>').attr('type', 'checkbox').
      	attr('name', $toggle.data('name')).
      	attr('id', $toggle.data('id')).
      	attr('class', $toggle.data('class')).
      	attr('value', ($toggle.data('value') || 'true'));
      $input.css({width: 0, height:0, position: 'absolute', opacity: 0});

      $container.append($yes).append($no);
      $toggle.append($container);
      $toggle.on('click', function (e) {
      	if(!$toggle.data('confirm') || confirm($toggle.data('confirm'))) {
      		$toggle.toggleClass('yes no');
	      	if ($input.is(':checked')) {
	      		$input.prop('checked', false);
	      	}
	      	else {
	      		$input.prop('checked', true);
	      	}
	      	$input.trigger('change');
      	}
        e.stopPropagation();
        return false;
      });
      $('label[for="' + $input.attr('id') + '"]').add($input.closest('label')).on('click', function(e) {
        $toggle.trigger('click');
        e.preventDefault();
      });

      $toggle.append($input);

      if (!$toggle.is('.yes') && !$toggle.is('.no')) {
      	$toggle.addClass('no');
      }

      if ($toggle.is('.yes')) {
      	$input.prop('checked', true);
      }
      else {
      	$input.prop('checked', false);
      }
    });

    return this;
  };
}(jQuery));


/*
 * String Helper
 */
var StringHelper = {
    addNumberDelimiter: function(number, options) {
        options = options || {};
        number = (number === 0 ? 0 : number || '').toString();
        let delimiter = options.delimiter || ' ';
        let separator = options.separator || '.';
        try {
            let parts = number.split('.');
            parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + delimiter);
            return parts.join(separator);
        } catch(e) {
            return number;
        }
    },


    random: function(length) {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < (length || 8); i++) {
            var randomPos = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPos, randomPos + 1);
        }
        return randomString;
    },


    simpleFormat: function(str) {
        str = jQuery('<div/>').text(str).html(); // escape html
        str = str.replace(/\r\n?/, "\n");
        str = jQuery.trim(str);

        if (str.length > 0) {
            str = str.replace(/\n\n+/g, '</p><p>');
            str = str.replace(/\n/g, '<br />');
            str = '<p>' + str + '</p>';
        }
        return str;
    }
};


/*
 * DataTables Helper
 */
var DataTablesHelper = {
    colIndex: function(tableSelector, colName) {
        var colAttr = jQuery(tableSelector).find(' th[data-col$="-' + colName + '"]').attr('data-col');
        return colAttr ? parseInt(colAttr.replace(/^(\d+)-.+$/, '$1'), 10) : null;
    },

    colIndices: function(tableSelector, colNames) {
        var indices = [];
        for (var i = 0; i < colNames.length; i++) {
            indices.push(DataTablesHelper.colIndex(tableSelector, colNames[i]));
        }
        return indices;
    },

    addColumnFilters: function(table) {
        jQuery.each(JSON.parse(jQuery(table).attr('data-filters')), function(colIndex, filterValues) {
            var column = table.api().column(colIndex);
            var columnHeader = jQuery(column.header());

            if (columnHeader.find('.filters').length > 0) {
              return;
            }

            if (!columnHeader.attr('data-col')) {
              columnHeader.attr('data-col', colIndex);
            }

            var filters = jQuery('<div class="filters"><a href="#" class="toggle"><i class="icon icon-filter"></i> ' + I18n.t('filter') + '</a></div>').appendTo(columnHeader);
            var selector = jQuery('<div class="selector" style="display:none;"><div class="values"></div></div>').appendTo(filters);
            var selectorValues = selector.find('.values');

            jQuery.each(filterValues, function(index, value) {
                selectorValues.append('<label data-text="' + value[1] + '"><input type="checkbox" value="' + value[0] + '" />' + value[1] + '</label>');
            });

            jQuery('<input type="text" class="search form-control" placeholder="' + I18n.t('search') + '" style="display: none;" />').prependTo(selector);
            jQuery('<a href="#" class="btn btn-xs btn-primary pull-right done">' + I18n.t('done') + '</a>').appendTo(selector);
            jQuery('<a href="#" class="btn btn-xs btn-default pull-right clear">' + I18n.t('clear') + '</a>').appendTo(selector);

            // For large enough selection display the search box
            if (filterValues.length > 10) {
                selector.find('input.search').show();
            }

            var options = {
                element: selector,
                target: filters,
                attachment: 'top left',
                targetAttachment: 'bottom left',
                constraints: [{
                    to: 'scrollParent',
                    attachment: 'together',
                    pin: true
                }]
            };

            jQuery(selector).attr('data-col-link', jQuery(filters).closest('th').attr('data-col'));
            jQuery(selector).attr('data-table-link', jQuery(filters).closest('table').attr('id'));

            var tether = new Tether(options);


            filters.add(jQuery(tether.element)).
                on('click', 'a.toggle, a.done', function(e) {
                    e.stopPropagation();
                    var s = jQuery(tether.element).toggle();
                    jQuery('.selector').not(s).hide();

                    if (s.is(':visible') && s.find('input.search').is(':visible')) {
                        s.find('input.search').focus();
                    }
                    tether.position();
                    return false;
                });
            selector.
                on('click', '.values input', function() {
                    var filters = jQuery(tether.target);
                    var container = jQuery(tether.element);
                    var vals = []
                    container.find('input:checked').each(function() {
                        vals.push(jQuery(this).val());
                    });

                    filters.find('a.toggle').removeClass('active');

                    if (vals.length > 0) {
                        filters.find('a.toggle').addClass('active');
                    }
                    if (table.api().ajax.url()) {
                        column.search(vals.join('|')).draw();
                    } else if (column.data().length > 0 && typeof column.data()[0] === 'object' && 'multiple_values' in column.data()[0]) {
                      // Front-end filtering with several elements per cell
                      // Data is expected to be formatted with formatMultipleSearchData()
                      column.search(vals.length > 0 ? ';(' + vals.join('|') + ');' : '', true, false).draw();
                    } else if (column.data().length > 0 && typeof column.data()[0] === 'object' && Array.isArray(column.data()[0])) {
                      // Filtering Arrays
                      column.search(vals.length > 0 ? "(" + vals.join("|") + ")" : "", true, false).draw();
                    } else {
                      // check if th has class filter-and to decide using AND or OR filter
                      if(filters.closest('th').hasClass('filter-and')){
                        var search = vals.length > 0 ? vals.map(function (v) { return '(?=.*' + (v == '' ? '\s*' : jQuery.fn.dataTable.util.escapeRegex(v)) + ')' }).join('') : '';
                      }
                      else{
                        var search = vals.length > 0 ? '(' + vals.map(function (v) { return '^' + (v == '' ? '\s*' : jQuery.fn.dataTable.util.escapeRegex(v)) + '$' }).join('|') + ')' : '';
                      }
                      column.search(search, true, false).draw();
                    }
                    tether.position();
                }).
                on('keyup', 'input.search', function(e) {
                    var regexp = new RegExp(this.value.split('').join('.*'), 'i');
                    jQuery(this).closest('.selector').find('.values label').each(function() {
                        jQuery(this).toggle(this.getAttribute('data-text').match(regexp) ? true : false);
                    });
                }).
                on('click', 'a.clear', function() {
                    jQuery(this).closest('.selector').find('.values input').prop('checked', false);
                    jQuery(this).closest('.selector').find('input.search').val('').trigger('keyup');
                    jQuery(tether.target).find('a.toggle').removeClass('active');
                    column.search('').draw();
                    tether.position();
                    return false;
                }).
                on('click', function(e) {
                    e.stopPropagation();
                });
        });

        // Hide column filters on click
        jQuery('body').not('.selector').on('click', function() {
            jQuery('.selector').each(function(){
                if(jQuery(this).is(':visible'))
                    jQuery(this).toggle();
            });
        });

        // Hide on table scroll
        table.closest('div').on('scroll',function() {
            jQuery('.selector').each(function(){
                if(jQuery(this).is(':visible'))
                    jQuery(this).toggle();
            });
        });

        // Reposition filter box on draw
        table.on('draw.dt', function() {
            Tether.position();
        });

        // Initialize selected filters from table state
        var state = null;

        if (table.api().init().stateLoadCallback) {
            state = table.api().init().stateLoadCallback();
        } else {
            state = table.api().state();
        }
            
        if (state && state.columns) {
            for (var i = 0; i < state.columns.length; i++) {
                var filtersFound = false;
                
                if (state.columns[i].search && state.columns[i].search.search != '') {
                    var values = state.columns[i].search.search.split('|');
                    filtersFound = values.length > 0;
            
                    for (var j = 0; j < values.length; j++) {
                        jQuery('[data-col-link^="' + i + '"] input[value="' + values[j] + '"]').prop('checked', true);
                    }
                }
                if (filtersFound) {
                    jQuery('[data-col^="' + i + '"] .filters a.toggle').addClass('active');
                }
            }
        }
    },

    addColumnSearchFields: function(table) {
      jQuery.each(JSON.parse(jQuery(table).attr('data-search-filters')), function(idx, colIndex) {
        var column = table.api().column(colIndex);
        var columnHeader = jQuery(column.header());

        if (columnHeader.find('.filters').length > 0) {
          return;
        }

        if (!columnHeader.attr('data-col')) {
          columnHeader.attr('data-col', colIndex);
        }

        var filters = jQuery('<div class="filters"><a href="#" class="toggle"><i class="icon icon-filter"></i> ' + I18n.t('filter') + '</a></div>').appendTo(columnHeader);
        var selector = jQuery('<div class="selector" style="display:none;"><div class="values"></div></div>').appendTo(filters);


        jQuery('<input type="text" class="search form-control" placeholder="' + I18n.t('search') + '" style="display: none;" />').prependTo(selector);
        jQuery('<a href="#" class="btn btn-xs btn-primary pull-right search">' + I18n.t('search') + '</a>').appendTo(selector);
        jQuery('<a href="#" class="btn btn-xs btn-default pull-right done">' + I18n.t('done') + '</a>').appendTo(selector);

        selector.find('input.search').show();
        var options = {
          element: selector,
          target: filters,
          attachment: 'top left',
          targetAttachment: 'bottom left',
          constraints: [{
              to: 'scrollParent',
              attachment: 'together',
              pin: true
          }]
        };

        jQuery(selector).attr('data-col-link', jQuery(filters).closest('th').attr('data-col'));
        jQuery(selector).attr('data-table-link', jQuery(filters).closest('table').attr('id'));

        var tether = new Tether(options);


        filters.add(jQuery(tether.element)).
            on('click', 'a.toggle, a.done', function(e) {
                e.stopPropagation();
                var s = jQuery(tether.element).toggle();
                jQuery('.selector').not(s).hide();

                if (s.is(':visible') && s.find('input.search').is(':visible')) {
                    s.find('input.search').focus();
                }
                tether.position();
                return false;
            });
        selector.
            on('click', 'a.search', function (){
              var regexp = new RegExp(jQuery(tether.element).find('input.search').val().split('').join('.*'), 'i');
              // Maybe need some check to avoid sql injection? and better identify this column to columns that have selection options
              column.search(`${jQuery(tether.element).find('input.search').val().toLowerCase()}_column_input_search`).draw();
              tether.position();
            }).
            on('click', function(e) {
                e.stopPropagation();
            });
      })

      // Hide column filters on click
      jQuery('body').not('.selector').on('click', function() {
        jQuery('.selector').each(function(){
            if(jQuery(this).is(':visible'))
                jQuery(this).toggle();
        });
      });

      // Hide on table scroll
      table.closest('div').on('scroll',function() {
          jQuery('.selector').each(function(){
              if(jQuery(this).is(':visible'))
                  jQuery(this).toggle();
          });
      });

      // Reposition filter box on draw
      table.on('draw.dt', function() {
          Tether.position();
      });
    },

    clearColumnFilters: function(tableSelector) {
        var table = jQuery(tableSelector);
        table.find('.filters .values input').prop('checked', false);
        table.find('.filters a.toggle').removeClass('active');
        jQuery('[data-table-link="' + table.attr('id') + '"]').find('.values input').prop('checked', false);
        table.DataTable().search('').columns().search('').draw();
    },

    formatMultipleSearchData: function(data) {
      return ';' + data.join(';') + ';';
    },

    togglePagination: function (object) {
        var pagination = $(object).closest('.dt-container').find('.dt-paging');
        if (pagination) pagination.toggle(object.api().page.info().pages > 1);

        var selector = $('.dt-length')
        selector.toggle(object.api().page.info().recordsDisplay > 10);
    },

    searchDelay: function( table, ms ) {
        // Reduce the search call frequency automatically to x milliseconds (for server-side processing mode)
        var tableId = table.settings()[0].sTableId;
        jQuery('.dt-search input[aria-controls="' + tableId + '"]') // select the correct input field
            .unbind() // Unbind previous default bindings
            .bind('keyup', (delay(function (e) { // Bind our desired behavior
                table.search(jQuery(this).val()).draw();
                return;
                }, ms) // Set delay in milliseconds
            ));

        function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);

                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, (args[0].which != 13) ? (ms || 0) : 0);
            };
        }
    },

    setAutoComplete: function(table, value = 'off') {
      var tableId = table.attr('id');
      jQuery('input[type="search"][aria-controls="' + tableId + '"]').attr('autocomplete', value);
    }
};


Array.prototype.clean = function(deleteValue) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == deleteValue) {         
      this.splice(i, 1);
      i--;
    }
  }
  return this;
};


// Polyfill for Object.assign (for IE)
if (typeof Object.assign != 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    'use strict';
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}


// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}


// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}


var ExplanationDialog = {};

ExplanationDialog.open = function(callback, dialogContent){

  var content = dialogContent + ' ' + '<textarea placeholder="' + I18n.t('explanation') +'" class="form-control" rows="10"></textarea>'
  var dialog = jQuery('#modal-dialog');
  dialog.find('.modal-title').html(I18n.t('explanation_for_action'));
  dialog.find('.modal-body').html(content);
  dialog.find('.modal-footer button.btn-primary').button('reset').removeAttr('disabled');

  var primaryButton = dialog.find('.modal-footer button.btn-primary');
  primaryButton.off('click').on('click', function(e) {
    var textareaVal = dialog.find('textarea').val(); 
    if (textareaVal.replace(/\s/g,'').length < 1){
      e.preventDefault();
      if (!dialog.find('.alert.alert-danger').length)
        dialog.find('.modal-body').prepend('<div class="alert alert-danger">' + I18n.t('explanation_required') + '</div>');
      return false;
    }

    jQuery(this).text(I18n.t('saving')).prop('disabled', true)
    setTimeout(() => {
      callback(textareaVal);
    }, 50);
  });

  dialog.modal();
  dialog.trigger('modal:opened');
}

ExplanationDialog.close = function() {
  var dialog = jQuery('#modal-dialog');
  dialog.modal('hide');
}

window.toggleCollapse = function(){
  var collapse = function(){
    jQuery(this).toggleClass('collapsed');
    jQuery(this).closest('#sidebar-wrapper').toggleClass('collapsed');
    jQuery('.application-container').toggleClass('collapsed');
  }

  jQuery('.navbar-collapse-toggle').off('click').on('click', function(){
    collapse.bind(this)();
    localStorageWithExpiry.setItem('collapseSidebar', jQuery(this).hasClass('collapsed'));
  });

  // Remeber selection
  if (localStorageWithExpiry.getItem('collapseSidebar') === true){
    var transitionSelection = jQuery('.navbar-collapse-toggle, .application-container').add(jQuery('.navbar-collapse-toggle').closest('#sidebar-wrapper'))
    
    if (transitionSelection.length > 0 && jQuery('.navbar-collapse-toggle').length > 0) {
      transitionSelection.addClass('no-transition');     // Disable css transitions 
      collapse.bind(jQuery('.navbar-collapse-toggle'))();
      transitionSelection[0].offsetHeight; // Required to trigger the change.
      transitionSelection.removeClass('no-transition'); // Enable css tranisition
    }
  }
};

/*
 * TinyMCE Helper
 */
var TinyMCEHelper = {
  init: function(options) {

      // Some overridable default options
      options = jQuery.extend(false, {
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks fullscreen',
              'insertdatetime media table contextmenu paste'
          ],
          toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
          contextmenu: 'link image inserttable | cut copy paste | cell row column deletetable',
          branding: false,
          paste_as_text: true,
          theme: 'modern',
          skin: 'lightgray'
      }, options || {});

      tinyMCE.baseURL = '/assets/tinymce';
      // Destroy old instances (needed if re-showing content from cache)
      jQuery(options.selector).each(function() {
          if (tinyMCE.get(this.id)) {
              try {
                  tinyMCE.remove('#' + this.id);
              } catch (e) {
                  // Fails every second time on Firefox although the editor still gets removed.
                  // Perhaps something to do with Turbo and caching.
              }
          }
      });

      tinyMCE.init(options);
  }
};




var SystemMessageHelper = {
  adjustContent: function (modifier) {
    var height = jQuery('.system-message').height() * modifier;
    var smTop = jQuery('.system-message').position().top;
    
    if (jQuery('.navbar-collapse-toggle').length > 0 && jQuery('#sidebar-wrapper').length > 0) {
      if (jQuery('#sidebar-wrapper').position().top + 2 < smTop + height || modifier == -1) {
        jQuery('.navbar-collapse-toggle').css({ bottom: jQuery('#sidebar-wrapper').position().top + height });
      }
    }

    ['.sidebar', '#sidebar-wrapper', '.breadcrumb'].forEach(function (selector) {
      var elem = jQuery(selector);
      if (elem.length > 0) {
        var top = elem.position().top;
        if (top + 2 < smTop + height || modifier == -1) elem.css({top: top + height})
      }
    });

    ['.main', '.main-fullscreen'].forEach(function (selector) {
      var offset = (selector == '.main-fullscreen' ? 2 : 0)
      var elem = jQuery(selector);
      if (elem.length > 0) {
        var margin = elem.outerHeight(true) - elem.outerHeight();
        if (margin + offset <= height || modifier == -1) elem.css({ 'margin-top': margin + height })
      }
    });
  },

  addClosingListener: function () {
    jQuery('.system-message #close-system-message').off('click').on('click', function () {
      this.adjustContent(-1);
      jQuery('.system-message').hide();
    }.bind(this));
  },
}


function getJsonFromUrl(query) {
  var result = {};
  query.split("&").forEach(function(part) {
    var item = part.split("=");
    result[decodeURIComponent(item[0])] = decodeURIComponent(item[1]);
  });
  return result;
}

// Function to get URL parameters
function getUrlParams(param_string) {
  var params = {};
  var regex = /([^&=]+)=([^&]*)/g;
  var match;

  while (match = regex.exec(param_string)) {
    let key = decodeURIComponent(match[1]);
    let value = decodeURIComponent(match[2]);

    // Support for array values
    if (key.endsWith('[]')) {
      key = key.slice(0, -2);
      if (!params[key]) params[key] = [];
      params[key].push(value);
    } else {
        params[key] = value;
    }
  }
  return params;
}

// jQuery downlaod function to trigger download as post (For requests with lot of params)
// param_string: parameters as html string to be passed as post body
jQuery.download = function(url, param_string, target_form){ 
  // Build a form
  var form = $('<form></form>').attr('action', url).attr('method', 'post').attr('target', '_blank');

  if (target_form != null) {
    form = jQuery(target_form).attr('action', url);
  }

  // Add the parameters passed
  // var params = getJsonFromUrl(param_string)
  // for (var name in params) {
  //   form.append($("<input></input>").attr('type', 'hidden').attr('name', name).attr('value', params[name]))
  // }

  var params = getUrlParams(param_string);
  $.each(params, function(k, v) {
    if (Array.isArray(v)) {
      $.each(v, function(i, v) {
        $('<input>').attr({ type: 'hidden', name: k + '[]', value: v}).appendTo(target_form);
      });
    } else {
      $('<input>').attr({type: 'hidden', name: k, value: v}).appendTo(target_form);
    }
  });

  form.append($("<input></input>").attr('type', 'hidden').attr('name', 'authenticity_token').attr('value', jQuery('meta[name="csrf-token"]').attr('content')));

  if (target_form == null) {
    //Send request
    form.appendTo('body').submit().remove();
  }
};

jQuery(window).on('resize load turbo:load', function() {
  var navbar_collapse_container= $('#navbar-collapse-container')
  var navbar_header_container = $('#navbar-user-header-container')
  var navbar_collapse = $('#navbar-user')

  if (window.innerWidth < 768 && navbar_collapse_container.hasClass('navbar-right')) {
    navbar_collapse_container.removeClass('navbar-right')
    $(navbar_collapse).appendTo(navbar_header_container)
  } else if (window.innerWidth >= 768 && !navbar_collapse_container.hasClass('navbar-right')) {
    navbar_collapse_container.addClass('navbar-right')
    $(navbar_collapse).appendTo(navbar_collapse_container)
  }
});

// The Navbar is marked data-turbo-permanent, so it doesnt reload on Turbo navigation (When switching locale you are taken back to an old view)
// To fix this, The language selector catch the turbo navigations/url changes and update it's redirect url accordingly
document.addEventListener("turbo:load", () => {
  const elements = document.querySelectorAll("[data-redirect-url]");
  elements.forEach((el) => {
    el.dataset.redirectUrl = window.location.href;
  })
});

var copyToClipboard = function(str){
  var el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};


// Adds style tag based on the amount of items in sidebar to support responsive resizing.
window.sidebarResize = function(){
  if (jQuery('#application-sidebar').length == 0) return;

  var topbarHeight = jQuery('#navbar').height() + jQuery('.system-message').height();
  var sideBarItemCount = jQuery('#application-sidebar ul li').length;
  var responsiveStyle = " #application-sidebar .sidebar-icon { height: calc( (100vh - " + topbarHeight + "px) / " + sideBarItemCount + "); max-height: 70px; min-height: 35px; text-align: center;} \n" + 
                        " #application-sidebar .sidebar-icon:before { font-size: calc( (100vh - " + topbarHeight + "px) / " + sideBarItemCount + " /2); margin-left: 0 !important;  } \n" + // Magic number 2; The amount of padding (top + bottom) is equal to the size of the icon
                        " #application-sidebar .sidebar-icon:before { padding-top: calc( (100vh - " + topbarHeight + "px) / " + sideBarItemCount + " * (1 / 4) - 3px);   } \n" +
                        " @media screen and (min-height: " + (70 * sideBarItemCount + topbarHeight) + "px) {\n" +
                        " #application-sidebar .sidebar-icon:before { \n" +
                        "    font-size: 4rem !important; \n" +
                        "    padding-top: 1rem !important; \n" +
                        " } " +
                        "}" +
                        " @media screen and (max-height: " + (35 * sideBarItemCount + topbarHeight) + "px) {\n" +
                        " #application-sidebar .sidebar-icon:before { \n" +
                        "    font-size: 18px !important; \n" +
                        "    padding-top: 5px !important; \n" +
                        " } " +
                        "}"
  jQuery('style#responsive-sidebar').remove();
  jQuery('body').append(
    jQuery('<style/>')
      .attr('id','responsive-sidebar')
      .attr('type', 'text/css')
      .text(responsiveStyle)
  );
}

// Scroll position catching
// To use add data-scroll-on-reload attribute, with a value unique selector to the container to be scrolled.
window.recoverScrollPosition = function() {
  document.querySelectorAll('[data-scroll-on-reload]').forEach(function(element){
    var initScroll = function() {
      var targetSelector = element.getAttribute('data-scroll-on-reload');
      var target = document.querySelector(targetSelector);
      var key = 'ScrollPosition_' + window.location.pathname + '|' + targetSelector;
      
      var storeYPosition = function(){
        localStorageWithExpiry.setItem(key, target.scrollTop);
      }

      var loadYPosition = function() {
        target.scroll(0, storedScrollPosition);
        localStorage.removeItem(key);
      }

      var storedScrollPosition = localStorageWithExpiry.getItem(key);
      if (storedScrollPosition) {
          loadYPosition()
      }

      element.addEventListener("click", storeYPosition, {once: true})
    }

    // Wrap to requestAnimationFrame to ensure that react has rendered
    window.requestAnimationFrame(initScroll);

  });  
}

/*
Known settings:
  'datetime-format'
  'date-format'
  'currency-format'
  'timezone'
*/

window.programmeSettings = function(setting){
  var railsSetting = document.querySelector('body').getAttribute('data-' + setting);

  // Rails strftime tokens aren't valid moment/dayjs format tokens. Use regex to replace
  // Only supports formats defined in ProjectService
  if (setting == 'datetime-format' || setting == 'date-format'){
    // default formats for surveys
    if(!railsSetting){
      return setting == 'datetime-format' ? 'YY-MM-DD HH:MM' : 'YY-MM-DD'
    }
    railsSetting = railsSetting.replace(/%d/g, 'DD')
      .replace(/%d/g, 'DD') // Zero padded day
      .replace(/%m/g, 'MM') // Zero padded month
      .replace(/%Y/g, 'YYYY') // 4-digit year
      .replace(/%e/g, 'D') // Day (w/o zero padding)
      .replace(/%b/g, 'MMM') // Month short name (Jan, Feb...)
      .replace(/%B/g, 'MMMM') // Month full name
      .replace(/%H/g, 'HH') // Hours 24-format
      .replace(/%M/g, 'mm') // Miinutes zero padded
      .replace(/%P/g, 'a') // AM/PM
      .replace(/%I/g, 'hh') // Hours 12-format zeropadded
  }

  return railsSetting;
}

function sortObject(obj) {
  return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key];
      return result;
  }, {});
}

function syntaxHighlight(json) {
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
          if (/:$/.test(match)) {
              cls = 'key';
          } else {
              cls = 'string';
          }
      } else if (/true|false/.test(match)) {
          cls = 'boolean';
      } else if (/null/.test(match)) {
          cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
  });
}

function validationErrorMessagesAsList(errors){
  return Object.values(errors).map(function(errList){ return errList.map(function(e){ return e.message})})
}

var localStorageWithExpiry = {
  isQuotaExceededError: function(err){
    return (
      err instanceof DOMException &&
      // everything except Firefox
      (err.code === 22 ||
        // Firefox
        err.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        err.name === "QuotaExceededError" ||
        // Firefox
        err.name === "NS_ERROR_DOM_QUOTA_REACHED")
    );
  },
  isStorageSupported: function(webStorageType){
    var storage;
    try {
      storage = window[webStorageType];
      if (!storage) {
        return false;
      }
      var x = `__storage_test__`;
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (err) {
      // We acknowledge a QuotaExceededError only if there's something already stored.
      var isValidQuotaExceededError = localStorageWithExpiry.isQuotaExceededError(err) && storage.length > 0;
      return isValidQuotaExceededError;
    }
  },
  setItem: function(key, value, timeToExpire = 1000 * 60 * 60 * 24 * 30){
    var now = new Date()

    // return if localStorage API is not supported. 
    if (!localStorageWithExpiry.isStorageSupported("localStorage")) {
      return;
    }
    
    // Loop all localStorage items and delete items that is expired
    for (var i = 0; i < localStorage.length; i++){
      try{
        var item = localStorageWithExpiry.getItem(localStorage.key(i))
      }catch(e){
        continue
      }
      if(item && item.expiry && item.expiry < now.getTime()){
        localStorage.removeItem(localStorage.key(i))
      }
    }

    // `item` is an object which contains the original value and the time when it's supposed to expire
    var item = {
      value: value,
      expiry: now.getTime() + timeToExpire,
    }

    try {
      localStorage.setItem(key, JSON.stringify(item))
    } catch (err) {
      // Handle the case where localStorage is full.
    }
    
  },
  getItem: function(key){
    // return null if localStorage API is not supported.
    if (!localStorageWithExpiry.isStorageSupported("localStorage")) {
      return null;
    }

    var itemStr = localStorage.getItem(key)

    // if the item doesn't exist return null
    if (!itemStr) {
      return null
    }

    var item = JSON.parse(itemStr)
    var now = new Date()

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value || item
  }
}

// Format a date with optional format, time, and timezone
//
// Examples:
// DT.dt('2026-03-10')
// DT.dt('2026-03-10', {datetime: true})
// DT.dt('2026-03-10', {format: 'DD MMM YYYY'})
//
const DT = {
    dt(value, {format = null, datetime = false, timezone = false} = {}) {
        if (!value) return value;
        try {
          format ||= programmeSettings(datetime ? 'datetime-format' : 'date-format');
          if (timezone) format = format + ' Z';

          const d = parseZone(value);
          if (!d.isValid()) return value;
          return d.format(format);
        } catch (e) {
          return value;
        }
    },
};

const Dropdown = {
  useSubmenu() {
    $('li.dropdown-submenu a[data-toggle="dropdown"]').on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $('li.dropdown-submenu').not($(this).parent()).removeClass('open');
      $(this).parent().toggleClass('open');
    });
  }
};

window.SmartME = SmartME;
window.StringHelper = StringHelper;
window.DataTablesHelper = DataTablesHelper;
window.ExplanationDialog = ExplanationDialog;
window.TinyMCEHelper = TinyMCEHelper;
window.SystemMessageHelper = SystemMessageHelper;
window.localStorageWithExpiry = localStorageWithExpiry;
window.copyToClipboard = copyToClipboard;
window.sidebarResize = sidebarResize;
window.validationErrorMessagesAsList = validationErrorMessagesAsList;
window.syntaxHighlight = syntaxHighlight;
window.sortObject = sortObject;
window.toggleCollapse = toggleCollapse;
window.DT = DT;
window.Dropdown = Dropdown;